import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';

// eslint-disable-next-line no-unused-vars
import { TweenLite, Sine, CSSPlugin } from 'gsap/all';

import ModalTransition from './organisms/transition';

import G1Login from '../../G1-login/G1-login';
import G2ForgotPassword from '../../G2-forgot-password/G2-forgot-password';


// Disabling no-unused-vars as GSAP requires the CSSPlugin to be loaded (and referenced)
// in order to animate on CSS properties. THis happens automatically with TweenMax, but
// not with TweenLite which we use here.
// eslint-disable-next-line no-unused-vars
const C = CSSPlugin;

class Login extends Component {
	state = {
		view: 'login',
		back: false,
	}

	timeout = 500;

	onClick = (event, view, back = false) => {
		event.preventDefault();
		this.setState({ view, back });
	};

	animateGroupHeight = (element) => {
		const { height } = element.getBoundingClientRect();
		const parent = element.parentElement;
		const animationTime = this.timeout / 1000;
		if (parent) {
			TweenLite.to(
				parent,
				animationTime,
				{
					height,
					ease: Sine.easeOut,
					onComplete: this.resetGroupHeight,
					onCompleteParams: [parent],
				},
			);
		}
	}

	setGroupHeight = (element) => {
		const { height } = element.getBoundingClientRect();
		const parent = element.parentElement;
		parent.style.height = `${height}px`;
	}

	resetGroupHeight = (element) => {
		element.style.height = '';
	}

	animateContainerHeight = (element, bool) => {
		const container = element.parentElement.parentElement;
		const parent = container.parentElement;
		const height = bool ? 0 : element.parentElement.parentElement.getBoundingClientRect().height;
		const animationTime = this.timeout / 1000;
		const marginTop = height === 0 ? 32 : 0;

		if (parent) {
			TweenLite.to(
				parent,
				animationTime,
				{
					height,
					marginTop,
					ease: Sine.easeOut,
					onComplete: this.resetContainerHeight,
					onCompleteParams: [parent, bool],
				},
			);
		}
	}

	setContainerHeight = (element) => {
		const container = element.parentElement.parentElement;
		const { height } = container.getBoundingClientRect();

		container.parentElement.style.height = `${height}px`;
	}

	resetContainerHeight = (element, bool) => {
		if (!bool) {
			element.style.height = '';
			element.style.marginTop = '';
		}
	}

	render() {
		const {
			data,
			onCloseClick,
		} = this.props;
		const {
			modalTitle,
			login,
			forgetPassword,
			invalidEmailText,
			invalidPasswordText,
		} = data;
		const { view, back } = this.state;

		return (
			<section className="modal__login">
				<button type="button" className="modal__close modal__login__close" onClick={onCloseClick} />
				<h1 className="modal__login__title">{modalTitle}</h1>
				<div className="modal__login__wrapper">
					<TransitionGroup className="modal__login__animated-group">
						<ModalTransition
							timeout={this.timeout}
							active={view === 'login' || false}
							back={back}
							callbacks={{
								animateHeight: this.animateGroupHeight,
								setGroupHeight: this.setGroupHeight,
							}}
						>
							<div className="modal__login__transition">
								<div className="modal__login__top">
									<G1Login view="top" data={{ invalidEmailText, invalidPasswordText, ...login }} callbacks={{ click: this.onClick }} />
								</div>
								<div className="modal__login__bottom">
									<G1Login data={{ ...login }} view="bottom" />
								</div>
							</div>
						</ModalTransition>
						<ModalTransition
							timeout={this.timeout}
							active={view === 'forgot-password' || false}
							back={back}
							callbacks={{
								animateHeight: this.animateGroupHeight,
								setGroupHeight: this.setGroupHeight,
							}}
						>
							<div className="modal__login__transition">
								<G2ForgotPassword data={{ invalidEmailText, ...forgetPassword }} callbacks={{ click: this.onClick }} />
							</div>
						</ModalTransition>
					</TransitionGroup>
				</div>
			</section>
		);
	}
}

Login.defaultProps = {
	onCloseClick: () => {},
};

Login.propTypes = {
	onCloseClick: PropTypes.func,
	data: PropTypes.shape({}).isRequired,
};

export default Login;
